/** Option schema for a language pack's line selector: marks EOS and keeps a retired current line selectable. */

import type { Feature } from '../../schemas/admin.schemas';
import { isEndOfSupport, normalizeLine } from './featureVersionInfo';

export function lineOptionSchema(
  feature: Feature,
  currentLine: unknown,
  today: Date = new Date(),
): Feature['option_schema'] {
  const key = feature.variant_key;
  const entry = key ? feature.option_schema[key] : undefined;
  if (!key || !entry?.enum) return feature.option_schema;
  const labels: Record<string, string> = { ...(entry.enum_labels ?? {}) };
  const lines = [...entry.enum];
  for (const line of lines) {
    if (isEndOfSupport(feature, line, today)) labels[line] = `${line} (end of support)`;
  }
  const current = normalizeLine(currentLine);
  if (current !== null && feature.retired_variants?.[current] && !lines.includes(current)) {
    lines.push(current);
    labels[current] = `${current} (retired)`;
  }
  if (Object.keys(labels).length === 0) return feature.option_schema;
  return { ...feature.option_schema, [key]: { ...entry, enum: lines, enum_labels: labels } };
}
